import { useState, useEffect } from "react";
import axios from "axios";

const useDatos = (url) => {
    const [datos, setDatos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);



    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(url);
                setDatos(response.data);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [url]);






    return { datos, loading, error };
};

export default useDatos;